import { FC } from 'react';
import { LinkButton, Modal } from 'src/components';
import { ROUTES } from 'src/constants/routes.const';
import { defineMessages, useIntl } from 'react-intl';
import BuddiesImage from '../buddies.png';
import * as S from './styles';

const msgs = defineMessages({
  title: { id: 'ai_buddies_locked_title_v2' },
  description: { id: 'ai_buddies_locked_description_v2' },
  cta: { id: 'ai_buddies_locked_cta' },
});

export const BuddyLockedModal: FC<{
  isOpen: boolean;
  onClose?: () => void;
}> = ({ isOpen, onClose }) => {
  const intl = useIntl();

  return (
    <Modal isOpen={isOpen} handleClose={onClose} darkCloseIcon>
      <S.ModalContent data-testid="buddyLockedModal">
        <S.Image src={BuddiesImage} />
        <S.Title data-testid="modal-title">{intl.formatMessage(msgs.title)}</S.Title>
        <S.Description data-testid="modal-description">
          {intl.formatMessage(msgs.description)}
        </S.Description>
        <LinkButton wide buttonType="primary" buttonSize="large" href={ROUTES.payment.plans}>
          {intl.formatMessage(msgs.cta)}
        </LinkButton>
      </S.ModalContent>
    </Modal>
  );
};
